import React,{useState,useEffect} from 'react';
import './AccessibilityFontSize.css'

const AccessibilityFontSize = (props) => {
    const [fontSize, setFontSize] = useState(0)
    const [isOpen, setIsOpen] = useState(false)

    // Initialize font size.
    useEffect(()=>{
        if(fontSize === 0 && (props.defaultsize??0) > 0)
            setFontSize(props.defaultsize)
        else if(fontSize === 0 && typeof props.defaultsize === 'undefined')
            setFontSize(0.8)
    },[props.defaultsize,fontSize,setFontSize])

    const Round1 = (numin) =>{ return Math.round(Number(numin*10))/10 }
    const changeSizeByBtn = (fsize) => {
        console.log(`fontSize Currently set to ${fontSize} setting to ${fsize}`)
        setFontSize(Round1(fsize))
        props.onChange(fsize)
    }

    const changeSizeBySlider = (e) => {
        const fsize = Round1((parseInt(e.target.value)*0.2)+0.4)
        setFontSize(fsize)
        props.onChange(fsize)
    }

    return (
        <div className="accessibility-container">
            <button
                type="button"
                className="accessibility-toggle"
                onClick={() => setIsOpen(!isOpen)}
                title="Font Size Options"
            >
                Aa
            </button>

            {isOpen && (
                <div className="accessibility-popup">
                    <div className="accessibility-popup-header">
                        <span>Font Size</span>
                        <button type="button" className="accessibility-close" onClick={() => setIsOpen(false)}>&times;</button>
                    </div>
                    <div className="accessibility-buttons">
                        <button type="button" name="accessbtn" id="bnt1" className={`fsbtn size1 ${Round1(fontSize)===0.4?'selected':''}`}
                            onClick={()=>changeSizeByBtn(0.4)}>A</button>

                        <button type="button" name="accessbtn" id="bnt2" className={`fsbtn size2 ${Round1(fontSize)===0.6?'selected':''}`}
                            onClick={()=>changeSizeByBtn(0.6)}>A</button>

                        <button type="button" name="accessbtn" id="btn3" className={`fsbtn size3 ${Round1(fontSize)===0.8?'selected':''}`}
                            onClick={()=>changeSizeByBtn(0.8)}>A</button>

                        <button type="button" name="accessbtn" id="btn4" className={`fsbtn size4 ${Round1(fontSize)===1?'selected':''}`}
                            onClick={()=>changeSizeByBtn(1)}>A</button>

                        <button type="button" name="accessbtn" id="btn5" className={`fsbtn size5 ${Round1(fontSize)===1.2?'selected':''}`}
                            onClick={()=>changeSizeByBtn(1.2)}>A</button>

                        <button type="button" name="accessbtn" id="btn6" className={`fsbtn size6 ${Round1(fontSize)===1.4?'selected':''}`}
                            onClick={() => changeSizeByBtn(1.4)}>A</button>

                        <button type="button" name="accessbtn" id="btn7" className={`fsbtn size7 ${Round1(fontSize)===1.6?'selected':''}`}
                            onClick={() => changeSizeByBtn(1.6)}>A</button>
                    </div>
                    <input name="accessbtn" id="slider" type="range" min="1" max="7" step='1' value={((fontSize-0.4)/0.2)}
                        onChange={changeSizeBySlider} className="accessibility-slider" />
                </div>
            )}
        </div>
    )
}

export default AccessibilityFontSize;
